import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import { Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { SliderControl } from '../../components/controls/SliderControl';

import { runFullSimulation } from '../../actions/simulationActions';

export const SliderWidget = ({ ...sliderProps }) => {
  return (
    <div style={{ padding: '0.5rem 0.75rem' }}>
      <SliderControl {...sliderProps} />
    </div>
  );
};

export class InvestmentFeesSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { fee_coefficient: 0.25 };

    this.delayOnParamsChanged = debounce(this.onParamsChanged.bind(this), 300);
    this.onParamsChanged();
  }

  onParamsChanged = () => {
    // this.props.runFullSimulation('DASHBOARD_', {
    //   fee_coefficient: 1 - this.state.fee_coefficient / 100,
    // });
  };

  onChange = (type, evt) => {
    if (this.state[type] != evt.detail.value) {
      this.setState({ [type]: evt.detail.value }, this.delayOnParamsChanged);
    }
  };

  render() {
    return (
      <div>
        <div style={{ background: '#e0f3ff', position: 'relative' }}>
          <Typography
            tag="div"
            use="caption"
            style={{
              position: 'absolute',
              width: '100px',
              textAlign: 'center',
              top: '16px',
              left: '217px',
              marginLeft: '-38px',
            }}
          >
            Average
          </Typography>
          <SliderWidget
            minLabel="Lowest Cost Funds"
            maxLabel="Highest Cost Funds"
            value={this.state.fee_coefficient}
            spec={{
              field_type: 'range',
              min: 0,
              max: 2,
              step_size: 0.05,
              _default: 5,
            }}
            valueFormatter={val => `${val.toFixed(2)}%`}
            onChange={e => this.onChange('fee_coefficient', e)}
            onInput={e => this.onChange('fee_coefficient', e)}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  runFullSimulation,
};

export default connect(null, mapDispatchToProps)(InvestmentFeesSidebar);
